import { useEffect, useState } from "react"
import { getInventarioDetById,postInventarioDet} from "../../services/InventariosDetServices"
import { InventariosDetFormContext } from "./InventariosDetContext"
import { useNavigate, useParams } from 'react-router-dom';

export const InventariosDetFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getInventarioDetByIdData(id)
    }, [])

    const getInventarioDetByIdData = async (id) => {
        let res = await getInventarioDetById(id)
        if (res) setReport(res)
    }

    const postInventarioDetData = async (body) => {
        const res = await postInventarioDet(body)
        if (res) navigate("/Inventarios");
    }
 
    return <InventariosDetFormContext.Provider value={{
        report,
        postInventarioDetData, 
    }} >
        {children}
    </InventariosDetFormContext.Provider>
}